import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Col, Form, FormGroup, Input, Row, Modal, UncontrolledTooltip } from "reactstrap";
import { Archive } from 'react-bootstrap-icons'
// import { getMaterials, postMaterial } from 'actions/procedureDefActions';
import { ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import DeleteButton from "./DeleteButton";
import EditButton from "./EditButton";
import Select from "react-select";
import { el } from 'date-fns/locale';
import ReportButtons from 'components/common/ReportButtons'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';

const MaterialProcedurePricing = ({ materials, deleteProcedureMaterial, editProcedureMaterial, unitTypes, materialTypes, available_material, postProcedureMaterial, activeProcedureID, getMaterialArchive, material_archive }) => {
    const [idtoEdit, setIdEdit] = useState(null)
    const inputCompanyIndex = useRef(null)
    const [modal, setModal] = useState(false);
    const [modalFunctionality, setmodalFunctionality] = useState(false);
    const toggle = () => setModal(!modal)
    const valueConvert = (val) => {
        let nr = Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
        return nr === "NaN" ? " X " : nr
    }

    const [formValues, setFormValues] = useState({
        material: null,
        company_index: "",
        name: "",
        'm_type': "",
        'unit_type': "",
        unit_price: 0,
        "number_of_procedures": '0',
        how_many_per_proc: "0",
        wklad: "0",
        procedure_materialcalc: "0",
        unit_type_name: "",
        ile_szt: ""
    })
    const [formValuesEdit, setFormValuesEdit] = useState({
        material: null,
        id: '',
        company_index_edit: "",
        name_edit: "",
        'm_type_edit': "",
        'unit_type_edit': "",
        unit_price_edit: null,
        "number_of_procedures_edit": '',
        how_many_per_proc_edit: "",
        wklad_edit: "",
        procedure_materialcalc_edit: "",
        material_edit: "",
        unit_type_name_edit: "",
        ile_szt_edit: ""

    })
    const [materialIndex, setMaterialIndex] = useState({ value: "", label: "" })
    const [materialIndexEdit, setMaterialIndexEdit] = useState({ value: "", label: "" })
    const [materialName, setMaterialName] = useState({ value: "", label: "" })
    const [materialNameEdit, setMaterialNameEdit] = useState({ value: "", label: "" })
    useEffect(() => {
        if (available_material.length > 0) {
            const newItem = available_material[0]
            // if (newItem) {
            //     setFormValues((prevState) => {
            //         const prevLoginValues = {...prevState};
            //         prevLoginValues.company_index = newItem.company_index;
            //         prevLoginValues.name = newItem.name;
            //         prevLoginValues.m_type = newItem.m_type;
            //         prevLoginValues.unit_price = newItem.unit_price;
            //         prevLoginValues.wklad = newItem.wklad;
            //         prevLoginValues.unit_type = newItem.unit_type;
            //         prevLoginValues.unit_type_name = newItem.unit_type_name;
            //         prevLoginValues.ile_szt = newItem.ile_szt;
            //         return prevLoginValues;
            //     });
            // }

        }


    }, [])
    const handleFieldChange = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormValues((prevState) => {
            const prevLoginValues = { ...prevState };
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }
    const handleEdit = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id;
        setFormValuesEdit((prevState) => {
            const prevLoginValues = { ...prevState };
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }
    const convertToEditableValue = (value) => {

        return (value.replace(',', '.'))
    }
    const seIdelement = (elem) => {
        let material_id = null
        if (available_material.filter(x => x.company_index == elem.company_index)[0]) {
            material_id = available_material.filter(x => x.company_index == elem.company_index)[0].id
            getMaterialArchive(material_id)
        }
        let temp = {
            material: elem.material,
            id: elem.id,
            name_edit: elem.name,
            'company_index_edit': elem.company_index,
            'm_type_edit': elem.m_type,
            'unit_type_edit': elem.unit_type,
            unit_price_edit: elem.unit_price,
            "number_of_procedures_edit": elem.number_of_procedures,
            how_many_per_proc_edit: elem.how_many_per_proc,
            wklad_edit: elem.wklad,
            procedure_materialcalc_edit: elem.procedure_materialcalc,
            material_edit: elem.material,
            ile_szt_edit: elem.ile_szt
        }
        setMaterialNameEdit({ value: elem.name, label: elem.name })
        setMaterialIndexEdit({ value: elem.company_index, label: elem.company_index })
        setIdEdit(elem.id, setFormValuesEdit(temp))
    }
    const addMaterial = (e) => {

        e.preventDefault();
        console.log('new material post')
        // formValues.material = available_material.filter(key => key.company_index === formValues.company_index);
        if (formValues.material > 0 && activeProcedureID && parseFloat(formValues.how_many_per_proc) > 0 && parseFloat(formValues.number_of_procedures) > 0) {

            if (formValues.material) { formValues.material = formValues.material } else { formValues.material = null }
            // formValues.procedure_materialcalc = activeProcedureID
            setFormValues({
                ...formValues,
                procedure_materialcalc: activeProcedureID
            })
            postProcedureMaterial({
                ...formValues,
                procedure_materialcalc: activeProcedureID
            })
            // postProcedureMaterial(formValues)
            setFormValues(({
                "number_of_procedures": '0',
                how_many_per_proc: "0",
                wklad: "0",
            })
            )
            // changeAddItem(inputCompanyIndex.current)
            changeAddItem(materialName, 'name')


        }


    }

    const sumbitEdit = (e, id) => {
        e.preventDefault();
        Object.keys(formValuesEdit).map(key => delete Object.assign(formValuesEdit, { [key.replace("_edit", "")]: formValuesEdit[key] })[key])
        if (formValuesEdit["company_index_edit"]) {
            formValuesEdit.company_index = formValuesEdit["company_index_edit"]
        }


        formValuesEdit.id = id;
        // if(available_material.filter(key => key.company_index === formValuesEdit.company_index)[0]) {formValuesEdit.material = available_material.filter(key => key.company_index === formValuesEdit.company_index)[0].id}
        if (formValuesEdit.material) { formValuesEdit.material = formValuesEdit.material }
        else { formValuesEdit.material = null }


        editProcedureMaterial(formValuesEdit)


    };
    const changeEditedItem = (e, name) => {
        let newItem = null
        if (name === 'index') newItem = available_material.filter(key => key.company_index === e.value)[0]
        else if (name === 'name') newItem = available_material.filter(key => key.name === e.value)[0]
        if (newItem) {

            setFormValuesEdit((prevState) => {
                const prevLoginValues = { ...prevState };
                prevLoginValues.company_index_edit = newItem.company_index;
                prevLoginValues.material_edit = newItem.id;
                prevLoginValues.material = newItem.id;
                prevLoginValues.name_edit = newItem.name;
                prevLoginValues.m_type_edit = newItem.m_type;
                prevLoginValues.unit_price_edit = newItem.unit_price;
                prevLoginValues.wklad_edit = newItem.wklad;
                prevLoginValues.unit_type_edit = newItem.unit_type;
                prevLoginValues.unit_type_edit_name = newItem.unit_type_name;
                prevLoginValues.ile_szt_edit = newItem.ile_szt;
                return prevLoginValues;

            });
            setMaterialNameEdit({ value: newItem.name, label: newItem.name })
            setMaterialIndexEdit({ value: newItem.company_index, label: newItem.company_index })
        }
    }


    const changeAddItem = (e, name) => {
        let newItem = null
        if (name === 'index') {
            if (e.value) {
                newItem = available_material.filter(key => key.company_index === e.value)[0]
            } else {
                newItem = available_material.filter(key => key.company_index === e.value)[0]
            }
        }
        else if (name === 'name') {
            if (e.value) {
                newItem = available_material.filter(key => key.name === e.value)[0]
            } else {
                newItem = available_material.filter(key => key.name === e.value)[0]
            }
        }

        if (newItem) {
            setFormValues((prevState) => {
                const prevLoginValues = { ...prevState };
                prevLoginValues.company_index = newItem.company_index;
                prevLoginValues.material = newItem.id;
                prevLoginValues.name = newItem.name;
                prevLoginValues.m_type = newItem.m_type;
                prevLoginValues.unit_price = newItem.unit_price;
                prevLoginValues.wklad = newItem.wklad;
                prevLoginValues.unit_type = newItem.unit_type;
                prevLoginValues.unit_type_name = newItem.unit_type_name;
                prevLoginValues.ile_szt = newItem.ile_szt;
                return prevLoginValues;
            });
            setMaterialName({ value: newItem.name, label: newItem.name })
            setMaterialIndex({ value: newItem.company_index, label: newItem.company_index })
        }


    }
    const showArchiveMat = (type) => {
        if (type === 'new') {
            setIdEdit(null)
            // var material = available_material.filter(key => key.company_index === formValues.company_index);
            getMaterialArchive(formValues.material)
            setModal(true)
        }
        else if (type === 'edit') {
            getMaterialArchive(formValuesEdit.material)
            setModal(true)
        }
    }
    const [archiveModal, setArchiveModal] = useState(false)
    const toggleArchiveModal = () => {
        setArchiveModal(!archiveModal)
    }
    const selectFromArchive = (material) => {
        if (!idtoEdit) {
            setFormValues((prevState) => {
                const prevLoginValues = { ...prevState };
                prevLoginValues.company_index = material.company_index;
                prevLoginValues.material = material.id;
                prevLoginValues.name = material.name;
                prevLoginValues.m_type = material.m_type;
                prevLoginValues.unit_price = material.unit_price;
                // prevLoginValues.wklad = material.wklad;
                prevLoginValues.unit_type = material.unit_type;
                prevLoginValues.unit_type_name = material.unit_type_name;
                prevLoginValues.ile_szt = material.ile_szt;
                return prevLoginValues;
            });
            setMaterialName({ value: material.name, label: material.name })
            setModal(false)
        }
        else {
            let temp = {
                material: material.id,
                id: formValuesEdit.id,
                name_edit: material.name,
                'company_index_edit': material.company_index,
                'm_type_edit': material.m_type,
                'unit_type_edit': material.unit_type,
                unit_price_edit: material.unit_price,
                "number_of_procedures_edit": material.number_of_procedures,
                how_many_per_proc_edit: material.how_many_per_proc,
                wklad_edit: material.wklad,
                procedure_materialcalc_edit: material.procedure_materialcalc,
                material_edit: material.id,
                ile_szt_edit: material.ile_szt
            }
            setMaterialNameEdit({ value: material.name, label: material.name })
            setFormValuesEdit(temp)
            setModal(false)

        }
    }
    const getTableRow = (values, format={}, mergeCells={col:[], row: []}) => {
        let row = []
        values.forEach( (val, i) => {
          row.push(new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ 
                  text: String(val), 
                  font:'Calibri', 
                  bold: format.bold||(format.firstBold&&i===0), 
                  color: format.textColor,
                  size: format.size,
                  allCaps: format.allCaps
                })],
                alignment: format.align[i]
              })
            ],
            rowSpan: mergeCells.row[i]?mergeCells.row[i]:1,
            columnSpan: mergeCells.col[i]?mergeCells.col[i]:1,
            verticalAlign: VerticalAlign.CENTER,
            shading: {
              fill: format.backgroundColor
            },
            margins: {
              marginUnitType: WidthType.DXA,
              top: 100, bottom: 100, left: 100, right: 100
            }
          }))
        })
        return row
      }
    const downloadDoc = () =>{
        let rows = []
        const headerStyle = {
          bold: true, backgroundColor:'#006ba7', textColor: 'white', size: '22', allCaps: true,
          align: Array(8).fill(AlignmentType.CENTER)
        }
        const bodyStyle = {
          bold: false, backgroundColor:'white', textColor: 'black', size: '24', allCaps: false,
          align: Array(4).fill(AlignmentType.LEFT).concat([AlignmentType.RIGHT, AlignmentType.LEFT]).concat(Array(3).fill(AlignmentType.RIGHT))
        }
        //header
        rows.push(new TableRow({
            children: getTableRow([
                'Indeks materiału',
                'Materiał/lek/środek spożywczy specjalnego przeznaczenia żywieniowego/wyrób medyczny',
                'Typ',
                'Liczba procedur',
                'Jednostka miary',
                'Ilość jednostek miary zużyta na realizację procedury',
                'Cena jednostki miary w zł',
                'Wkład do kosztu jednostkowego w zł'
            ], headerStyle),
            tableHeader: true
        }))
        //body
        materials.map((elem, i) => {
          rows.push(new TableRow({
            children: getTableRow([
                available_material.filter(key => key.company_index === elem.company_index)[0] ? available_material.filter(key => key.company_index === elem.company_index)[0].company_index : "",
                elem.name,
                elem.m_type,
                valueConvert(elem.number_of_procedures),
                elem.unit_type,
                valueConvert(elem.how_many_per_proc),
                valueConvert(elem.unit_price),
                valueConvert(elem.wklad)
            ], bodyStyle)
          }))
        })

        rows.push(new TableRow({
            children: getTableRow([
                'Wartość ogółem',
                materials&&materials.length>0?valueConvert(materials.map(item => Number(item.wklad)).reduce((prev, next) => prev+next)):0
            ], {...bodyStyle, align: [AlignmentType.LEFT, AlignmentType.RIGHT]}, {col:[7,1], row: []})
        }))
    
        let table = new Table({
          rows: rows,
          width: { size: 100, type: WidthType.PERCENTAGE}
        })
    
        //DOCUMENT
        let paragraphs = [
          new Paragraph({
            children:[
              new TextRun({text: 'Tabela zużycia materiałów, leków i wyrobów medycznych'+'\n\n', font:'Calibri', bold: true, size: 26 })
            ],
            alignment: AlignmentType.JUSTIFIED,
            spacing: { after: 200 }
          }),
          table
        ]
    
        let doc = new Document({ 
          sections: [{
            properties: { page: { 
              margin: {
                  top: convertMillimetersToTwip(15),
                  right: convertMillimetersToTwip(15),
                  bottom: convertMillimetersToTwip(15),
                  left: convertMillimetersToTwip(15),
              },
            }},
            children: paragraphs
          }] 
        })
    
        // doc.Settings.addCompatibility().doNotExpandShiftReturn();
    
        Packer.toBlob(doc).then(blob =>{
          saveAs(blob, 'Tabela zużycia materiałów, leków i wyrobów medycznych.doc')
        })
    }
    const downloadCSV = () =>{
        let filename = "Tabela zużycia materiałów, leków i wyrobów medycznych"+'.csv';
        var tableSelect = document.getElementById('wycenaMaterials')
        var tableHTML = tableSelect.outerHTML;
        var csv = [];
        var rows = document.querySelectorAll(`#wycenaMaterials tr`);
        
        for (var i = 0; i < rows.length; i++) {
            var row = [], cols = rows[i].querySelectorAll("td, th");
            if(i==1){}
            else if(i==rows.length-1){row.push(cols[0].innerText); row.push(""); row.push(""); row.push(""); row.push("");row.push("");row.push("");row.push(cols[cols.length-2].innerText);csv.push(row.join(";"));}
            else {for (var j = 0; j < cols.length-1; j++) row.push(cols[j].innerText)
            csv.push(row.join(";"));		}}
            csv = csv.join("\n")

        var csvFile;
        var downloadLink;
        var universalBOM = "\uFEFF";
        csvFile = new Blob(['\ufeff',csv], {type: "text/csv;charset=UTF-8"});
        downloadLink = document.createElement("a");
        downloadLink.download = filename;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click(); 
    }
    const downloadXlsx = () =>{
        var wb = XLSX.utils.table_to_book(document.getElementById('wycenaMaterials'), {sheet:"wycena", raw:true});
        //
        var ws = wb.Sheets["wycena"];
        var range = XLSX.utils.decode_range(ws['!fullref']);
        // console.log(range.e.r)
        for(let i=1;i<=range.e.r+1;i++){
            if(i==1){delete ws[`I${i}`];}
         //  get the current sheet
         if(i==2) {delete ws[`A${i}`]; delete ws[`B${i}`];delete ws[`C${i}`];delete ws[`D${i}`];delete ws[`E${i}`];delete ws[`F${i}`];delete ws[`G${i}`]; delete ws[`H${i}`];delete ws[`I${i}`]; }
       
        // if(i==1) {delete ws} // delete old formatted text if it exists
    
        // console.log(ws[`D${i}`].w) // refresh cell
        
        }

        //
        var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
        let filename = "Tabela zużycia materiałów, leków i wyrobów medycznych"+'.xlsx';
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
    }
    const s2ab = (s)=>{
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    return (<div className="content">
        <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} color='wycena'/>
        <table className='table table-border tableWycena' id="wycenaMaterials">
            <thead className=''>
                <tr className=''>
                    <th className="headerColor" style={{ width: "130px" }}>Indeks materiału</th>
                    <th className="headerColor">Materiał/lek/środek spożywczy specjalnego przeznaczenia
                        żywieniowego/wyrób medyczny
                    </th>
                    <th className="headerColor">Typ</th>
                    <th className="headerColor">Liczba Procedur</th>
                    <th className="headerColor">Jednostka miary</th>
                    <th className="headerColor">Ilość jednostek miary zużyta na realizację procedury</th>
                    <th className="headerColor">Cena jednostki miary w zł</th>
                    <th className="headerColor">Wkład do kosztu jednostkowego w zł
                    </th>
                    <th className="headerColor">Opcje</th>
                </tr>
            </thead>
            <tbody>
                {/* NEW ENTRY */}
                <tr>
                    <td>
                        <div style={{ display: "grid", gridTemplateColumns: "10fr 1fr" }}>
                            <div style={{ width: "98%" }}>
                                <Select ref={inputCompanyIndex}
                                    value={materialIndex}
                                    className="react-select select-wycena"
                                    classNamePrefix="react-select"
                                    onChange={(value) => changeAddItem(value, "index")}
                                    options={available_material.map((key, i) => { return { value: key.company_index, label: key.company_index } })}

                                />
                            </div>
                            {formValues['company_index'] && <>
                                <i id="archAdd" class="far fa-folder-open" style={{ alignSelf: "center", cursor: "pointer" }} 
                                    onClick={() => { showArchiveMat('new') }}></i>
                                <UncontrolledTooltip
                                    delay={{ show: 0, hide: 200 }}
                                    placement="bottom"
                                    target='archAdd'
                                >
                                    Pokaż archiwum
                                </UncontrolledTooltip>
                            </>}
                        </div>
                    </td>
                    <td>
                        <Select
                            value={materialName}
                            className="react-select select-wycena"
                            classNamePrefix="react-select"
                            onChange={(value) => changeAddItem(value, "name")}
                            options={available_material.map((key, i) => { return { value: key.name, label: key.name } })}
                        />
                    </td>
                    <td><Input
                        className="border-input"
                        type="text"
                        id="m_type"
                        disabled={true}
                        value={materialTypes && materialTypes.filter(x => x.id === formValues['m_type'])[0] ? materialTypes.filter(x => x.id === formValues['m_type'])[0].name : ""}
                    /></td>
                    <td><Input
                        className="border-input"
                        type="number"
                        min='0'
                        id="number_of_procedures"
                        value={formValues['number_of_procedures']}
                        onChange={(e) => {
                            handleFieldChange(e)
                        }}
                    /></td>
                    <td><Input
                        className="border-input"
                        type="text"
                        id="unit_type"
                        disabled={true}
                        value={unitTypes && unitTypes.filter(x => x.id === formValues['unit_type'])[0] ? unitTypes.filter(x => x.id === formValues['unit_type'])[0].name : ""}
                    /></td>
                    <td><Input
                        className="border-input"
                        type="number"
                        min='0'
                        id="how_many_per_proc"
                        value={formValues['how_many_per_proc']}
                        onChange={(e) => {
                            handleFieldChange(e)
                        }}
                    />
                    </td>
                    {unitTypes && unitTypes.filter(x => x.id === formValues['unit_type'])[0] && unitTypes.filter(x => x.id === formValues['unit_type'])[0].name === "opakowanie" &&
                        <UncontrolledTooltip
                            delay={0}
                            placement="top"
                            target={`how_many_per_proc`}
                        >
                            W opakowaniu znajduje się {formValues['ile_szt']} szt. Pamiętaj, że należy wpisać liczbę w sztukach użytych na procedurę, a nie liczbę opakowań!
                        </UncontrolledTooltip>}
                    <td className='rightAlignCell'><Input
                        className="border-input"
                        type="text"
                        id="unit_price"
                        disabled={true}
                        value={parseFloat(formValues['unit_price']).toFixed(2).toString().replace('.', ',')}
                    /></td>
                    <td>
                        obliczany po dodaniu pozycji
                    </td>
                    <td className='text-center'>
                        <Button style={{ width: "60px" }}
                            className="btn-round btn m-0"
                            color="wycena"
                            type="button"
                            onClick={(e) => addMaterial(e)}
                            id={`add-new`}
                            outline
                        >
                            <i className='nc-icon nc-simple-add'></i>
                        </Button>
                        <UncontrolledTooltip
                            delay={0}
                            placement="top"
                            target={`add-new`}
                        >
                            Dodaj
                        </UncontrolledTooltip>
                    </td>
                </tr>
                {materials && materials.map((elem, i) => {
                    return <>
                        {idtoEdit !== elem.id ?
                            <tr>
                                {/* EXISTING ENTRIES */}
                                <td className="">{available_material.filter(key => key.company_index === elem.company_index)[0] ? available_material.filter(key => key.company_index === elem.company_index)[0].company_index : ""}</td>
                                <td className="">{elem.name}</td>
                                <td className="">{elem.m_type}</td>
                                <td className="rightAlignCell">{valueConvert(elem.number_of_procedures)}</td>
                                <td className="">{elem.unit_type}</td>
                                <td className="rightAlignCell">{valueConvert(elem.how_many_per_proc)}</td>
                                <td className="rightAlignCell">{valueConvert(elem.unit_price)}</td>
                                <td className="rightAlignCell">{valueConvert(elem.wklad)}</td>
                                {idtoEdit !== elem.id ?
                                    <td style={{ whiteSpace: 'nowrap' }}>
                                        <Button
                                            className="btn-link "
                                            color="success"
                                            data-toggle="tooltip"
                                            id={`editM-${i}`}
                                            size="sm"
                                            type="button"
                                            onClick={(e) => {
                                                seIdelement(elem)
                                            }}

                                        >
                                            <i className="fas fa-edit"></i>
                                        </Button>
                                        <UncontrolledTooltip
                                            delay={{ show: 0, hide: 200 }}
                                            placement="top"
                                            target={`editM-${i}`}
                                        >
                                            Edytuj
                                        </UncontrolledTooltip>
                                        {/* <EditButton idx={i} elem={elem} edit={seIdelement}/> */}
                                        <DeleteButton idx={'material-remove' + i}
                                            id={elem.id}
                                            deleteFunc={deleteProcedureMaterial}
                                            text={"koszt materiałowy?"} />
                                    </td> : <td>{/* UNUSED? */}
                                        <span style={{ marginRight: "5px", cursor: "pointer" }} onClick={() => {
                                            setIdEdit(null)
                                        }}>Anuluj</span>&nbsp;&nbsp;<span style={{ marginLeft: "5px" }}>OK</span></td>}
                            </tr> : <tr>
                                {/* EDIT ENTRY */}
                                <td className="">
                                    {/* <Input type="select" name="opk" id="comapny_index_edit"
                                           value={formValuesEdit['company_index_edit']}
                                           onChange={(e) => changeEditedItem(e,'index')}>
                                        {available_material.length > 0 && available_material.map(key => {
                                            return <option value={key.company_index}>{key.company_index}</option>
                                        })}
                                    </Input> */}
                                    <div style={{ display: "grid", gridTemplateColumns: "10fr 1fr" }}>
                                        <div style={{ width: '98%' }}><Select
                                            value={materialIndexEdit}
                                            className="react-select select-wycena"
                                            classNamePrefix="react-select"
                                            onChange={(value) => changeEditedItem(value, "index")}
                                            options={available_material.map((key, i) => { return { value: key.company_index, label: key.company_index } })}
                                        /></div>
                                        {formValuesEdit['company_index_edit'] && <><i className="far fa-folder-open" id="archEditMat" style={{ alignSelf:"center", cursor: "pointer" }} onClick={() => { showArchiveMat('edit') }}></i>
                                            <UncontrolledTooltip
                                                delay={{ show: 0, hide: 200 }}
                                                placement="bottom"
                                                target='archEditMat'
                                            >
                                                Pokaż archiwum
                                            </UncontrolledTooltip></>}</div>

                                    {/*<Button onClick={e=>toggle()} ><Archive/></Button>*/}
                                </td>
                                <td>
                                    {/* <Input
                                    className="border-input"
                                    type="text"
                                    id="name_edit"
                                    disabled={true}
                                    value={formValuesEdit['name_edit']}
                                /> */}
                                    {<Select
                                        value={materialNameEdit}
                                        className="react-select select-wycena"
                                        classNamePrefix="react-select"
                                        onChange={(value) => changeEditedItem(value, "name")}
                                        options={available_material.map((key, i) => { return { value: key.name, label: key.name } })}
                                    />}
                                </td>
                                <td><Input
                                    className="border-input"
                                    type="text"
                                    id="m_type_edit"
                                    disabled={true}
                                    value={formValuesEdit['m_type_edit']}
                                /></td>
                                <td><Input
                                    className="border-input"
                                    type="number"
                                    min='0'
                                    id="number_of_procedures_edit"
                                    value={formValuesEdit['number_of_procedures_edit']}
                                    onChange={(e) => {
                                        handleEdit(e)
                                    }}
                                /></td>
                                <td><Input
                                    className="border-input"
                                    type="text"
                                    id="unit_type_edit"
                                    disabled={true}
                                    value={formValuesEdit['unit_type_edit']}
                                /></td>
                                <td><Input
                                    className="border-input"
                                    type="number"
                                    min='0'
                                    id="how_many_per_proc_edit"
                                    value={formValuesEdit['how_many_per_proc_edit']}
                                    onChange={(e) => {
                                        handleEdit(e)
                                    }}
                                /></td>
                                {formValuesEdit['unit_type_edit'] === 'opakowanie' && <UncontrolledTooltip
                                    delay={0}
                                    placement="top"
                                    target={`how_many_per_proc_edit`}>
                                    W opakowaniu znajduje się {formValuesEdit['ile_szt_edit']} szt. Pamiętaj, że należy wpisać liczbę w sztukach użytych na procedurę, a nie liczbę opakowań!
                                </UncontrolledTooltip>}
                                <td className='rightAlignCell'><Input
                                    className="border-input"
                                    type="text"
                                    id="unit_price_edit"
                                    disabled={true}
                                    value={parseFloat(formValuesEdit['unit_price_edit']).toFixed(2).toString().replace('.', ',')}
                                /></td>
                                <td>
                                {formValuesEdit.hasOwnProperty('wklad_edit') && (formValuesEdit['wklad_edit'] !== NaN || formValuesEdit['wklad_edit'] !== 'NaN') && formValuesEdit['wklad_edit']   ?<Input
                                    className="border-input"
                                    type="text"
                                    id="wklad_edit"
                                    disabled={true}
                                    value={parseFloat(formValuesEdit['wklad_edit']).toFixed(2).toString().replace('.', ',')}
                                />:<>Wyliczony po zatwierdzeniu edycji</>}</td>
                                <td style={{ whiteSpace: 'nowrap' }} >
                                    <Button
                                        className="btn-link "
                                        color="success"
                                        data-toggle="tooltip"
                                        size="sm"
                                        type="button"
                                        id="checkEditMat"
                                        onClick={(e) => {
                                            sumbitEdit(e, idtoEdit);
                                            setIdEdit(null)
                                        }}

                                    >
                                        <i className="fas fa-check"></i>
                                    </Button>
                                    {/* <UncontrolledTooltip delay={0} placement="top" target={`checkEditMat`} >
                                    Zapisz zmiany
                                </UncontrolledTooltip> */}
                                    <Button
                                        className="btn-link"
                                        color="danger"
                                        data-toggle="tooltip"
                                        size="sm"
                                        type="button"
                                        onClick={() => {
                                            setIdEdit(null)
                                        }}
                                        id='cancelEditMat'
                                    >
                                        <i className="fas fa-times"></i>
                                    </Button>
                                    <UncontrolledTooltip delay={0} placement="top" target={`cancelEditMat`} >
                                        Odrzuć zmiany
                                    </UncontrolledTooltip>
                                </td>
                            </tr>}

                    </>
                })}
                <tr style={{fontWeight: 'bold'}}>
                    <td colSpan='7'>Wartość ogółem</td>
                    <td className='rightAlignCell'>
                        {materials&&materials.length>0?
                            valueConvert(materials.map(item => Number(item.wklad)).reduce((prev, next) => prev+next))
                        :0}
                    </td>
                    <td></td>
                </tr>
            </tbody>
        </table>

        <Modal isOpen={modal} toggle={toggle} size='xl'>
            <ModalHeader >Archiwalne wersje wybranego materiału</ModalHeader>
            <ModalBody>
                <table className='table table-border tableWycena'>
                    <thead className=''>
                        <tr className=''>
                            <th className="headerColorCustom">Typ materiału</th>
                            <th className="headerColorCustom">Data obowiązywania</th>
                            <th className="headerColorCustom">Cena jednostki miary w zł</th>
                            <th className="headerColorCustom">Jednostka miary</th>
                            <th className="headerColorCustom">Opcje</th>
                        </tr>
                    </thead>
                    <tbody>

                        {material_archive.length > 0 && material_archive.map((elem) => <tr>
                            <td className="">{elem.name}</td>
                            <td className="rightAlignCell">{elem.date_mat !=='1900.01.01' ? elem.date_mat:""}</td>
                            <td className="rightAlignCell">{parseFloat(elem.unit_price).toFixed(2).toString().replace('.', ',')}</td>
                            <td className="">{elem.unit_type_name}</td>
                            <td className="rightAlignCell"><Button color="wycena" outline className='btn-round' onClick={() => { selectFromArchive(elem) }}>Wybierz</Button></td>

                        </tr>)}


                    </tbody>
                </table>
            </ModalBody>
            <ModalFooter>
                <Button style={{ width: "100%" }} color="wycena" className="btn-link" onClick={toggle}>Zamknij</Button>
            </ModalFooter>
        </Modal>
        <Modal
            size='lg'
            modalClassName="modal-primary"
            isOpen={archiveModal}
            toggle={toggleArchiveModal}
        >
            <div className="modal-header justify-content-center">
                <div className="modal-profile ml-auto mr-auto">
                    <i className="far fa-file-archive" />
                </div>
            </div>
            <div className="modal-body">
            </div>
            <div className="modal-footer">
                <Button
                    className='btn-link'
                    color="wycena"
                    style={{ width: '100%' }}
                    data-dismiss="modal"
                    type="button"
                    onClick={e => {
                        toggleArchiveModal()
                    }}>
                    Zamknij
                </Button>
            </div>
        </Modal>


    </div>
    )
}
// const mapStateToProps = state => ({
//     materials:state.procedureDefReducer.materials})
export default MaterialProcedurePricing
